import { useForm } from "react-hook-form"
// components
import {
    AddressDetails,
    PersonalDetails,
    ReferenceDetails,
} from "./UserDetailsForms"
import { FormNav } from "../Common/Nav"
import { FormWrapper } from "@components/Form"
// hooks
import useAuth from "@hooks/useAuth"

export const SignUpForm = ({ formSteps, updateFormSteps }) => {
    const { handleSignUp } = useAuth()

    // react hook form
    // there is no property name state
    const {
        control,
        watch,
        formState: { errors },
        setValue,
        handleSubmit,
    } = useForm({
        defaultValues: {
            firstName: "",
            lastName: "",
            contact: "",
            email: "",
            password: "",
            repeatPassword: "",
            country: "",
            province: "",
            pincode: "",
            address: "",
            referenceNumber: "",
            eye: "",
        },
    })

    // handler
    const onSubmit = (data) => {
        if (formSteps === 3) {
            handleSignUp({
                ...data,
                requestType: "Patient",
                contact: `+${data.contact}`,
                referenceNumber:
                    data.referenceNumber === ""
                        ? undefined
                        : data.referenceNumber,
            })
        } else {
            updateFormSteps(formSteps + 1)
        }
    }

    // form steps
    const formStepComponents = [
        {
            key: 1,
            title: "Individual Info",
            form: (
                <PersonalDetails
                    watch={watch}
                    control={control}
                    errors={errors}
                />
            ),
        },
        {
            key: 2,
            title: "Address Info",
            form: (
                <AddressDetails
                    watch={watch}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                />
            ),
        },
        {
            key: 3,
            title: "Medical Info",
            form: <ReferenceDetails control={control} errors={errors} />,
        },
    ]

    const currentFormStepComponent = formStepComponents.find(
        (step) => step.key === formSteps
    )

    return (
        <>
            <FormNav
                title="Create Account"
                stepTitle={currentFormStepComponent.title}
                totalSteps={formStepComponents.length}
                formSteps={currentFormStepComponent.key}
                updateFormSteps={updateFormSteps}
            />
            <FormWrapper onSubmit={handleSubmit(onSubmit)}>
                {currentFormStepComponent.form}
            </FormWrapper>
        </>
    )
}
